import {Injectable, Injector, NgZone} from '@angular/core';
import {Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';

import {Constants} from '../constants/constants';
import {Spring} from '../spring/spring';
import {CrudService} from '../crud/crud.service';
import {UpcontroService} from './upcontro.service';
import {UtileriasService} from './utilerias.service';
import {UspreferService} from './usprefer.service';
import {ConfigService} from './config.service';
import * as swalFunctions from '../data/sweet-alert';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';


@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  private refreshTokenTimeout?: any;
  refreshTokenJSON: any = {
    'refreshToken': ''
  };
  intervaloSesionUsuario: any;
  swal = swalFunctions;

  constructor(
    private router: Router,
    private http: HttpClient,
    private constants: Constants,
    private zone: NgZone,
    private crud: CrudService,
    private spring: Spring,
    private utileriasService: UtileriasService,
    private upcontroService: UpcontroService,
    private uspreferService: UspreferService,
    private _config: ConfigService,
    private _utileria: UtileriasService,
    private injector: Injector
  ) {

    this.zone.runOutsideAngular(() => {
      window.document.addEventListener('mousemove', this.mouseMove.bind(this));
      window.document.addEventListener('keydown', this.keyDown.bind(this));
    });

    clearInterval(this.intervaloSesionUsuario);
    this.iniciaInterval();
  }

  public get userValue() {
    return JSON.parse(sessionStorage.getItem('user'));
  }

  public get idUsuario() {
    const userJson = JSON.parse(sessionStorage.getItem('user'));
    if (userJson == null) {
      return null;
    } else {
      return userJson.idusuari;
    }
  }

  public isLoggedIn(): boolean {
    const userJson = JSON.parse(sessionStorage.getItem('user'));
    return userJson ? true : false;
  }

  login(usuario: any) {
    return this.crud.post(`${this.spring.SIGNIN_TOKEN}`, usuario)
      .pipe(map(user => {
        sessionStorage.setItem('user', JSON.stringify(user));
        this.descargarPermisosUsuario(user.idusuari);
        this.descargaPreferenciasUsuario(user.idusuari);
        this.startRefreshTokenTimer();
        setTimeout(() => {
          this._config.setTemaUsuario();
        }, 1000);
        this.iniciaInterval();
        return user;
      }));
  }

  refreshUserJson(userValue) {
    sessionStorage.setItem('user', JSON.stringify(userValue));
  }

  descargarPermisosUsuario(idusuari: number) {
    this.upcontroService.getPermisosUsuario(idusuari).subscribe({
      next: (permisos) => {
        sessionStorage.setItem('userData', this.utileriasService.encrypt(JSON.stringify(permisos)));
      }
    });
  }

  descargaPreferenciasUsuario(idusuari: number): void {
    this.uspreferService.getPreferenciasUsuario(idusuari).subscribe({
      next: (preferencias) => {
        for (const usprefer of preferencias) {
          sessionStorage.setItem(usprefer.tabla, this.utileriasService.encrypt(JSON.stringify(JSON.parse(usprefer.preferencias))));
        }
      }
    })
  }

  eliminardatosoptimizacion(idusuari: number) {
    this.uspreferService.eliminardatosoptimizacion(idusuari).subscribe();
    this.uspreferService.getPreferenciasUsuario(idusuari).subscribe({
      next: (preferencias) => {
        for (const usprefer of preferencias) {
          sessionStorage.removeItem(usprefer.tabla);
        }
      }
    })
  }


  logout(inactividad?: boolean) {
    const userJson = JSON.parse(sessionStorage.getItem('user'));
    if (userJson) {
      this.refreshTokenJSON.refreshToken = userJson.refreshToken;
      this.crud.post(`${this.spring.SIGNOUT_TOKEN}`, this.refreshTokenJSON).subscribe();
    }
    this.stopRefreshTokenTimer();
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('cbListadoVacaciones');
    if (inactividad !== undefined) {
      const modalService = this.injector.get(NgbModal); // Se inyecta manual para evitar Circular dependency
      modalService.dismissAll(); // Cierra todas las modales activas.
      sessionStorage.setItem('cierreAuto', '1');
      window.open('#/login', '_self');
    } else {
      void this.router.navigate(['/login']);
    }

  }

  refreshToken() {
    const userJson = JSON.parse(sessionStorage.getItem('user'));
    if (userJson !== null) {
      this.refreshTokenJSON.refreshToken = userJson.refreshToken;
      return this.crud.post(`${this.spring.REFRESH_TOKEN}`, this.refreshTokenJSON)
        .pipe(map((user) => {
          // console.log('refreshToken() METHOD');
          userJson.token = user.accessToken; // Actualiza valor del token
          sessionStorage.setItem('user', JSON.stringify(userJson));
          this.startRefreshTokenTimer();
          return user;
        }));
    } else {
      //this.logout();
    }
  }

  // helper methods
  private startRefreshTokenTimer() {
    // parse json object from base64 encoded jwt token
    // console.log('startRefreshTokenTimer() METHOD');
    // console.log(this.userValue.token);
    const userJson = JSON.parse(sessionStorage.getItem('user'));
    const jwtBase64 = userJson!.token!.split('.')[1];
    const jwtToken = JSON.parse(atob(jwtBase64));

    // set a timeout to refresh the token a minute before it expires
    const expires = new Date(jwtToken.exp * 1000);
    const timeout = expires.getTime() - Date.now() - (15 * 1000);
    // console.log('Fecha expiración: ' + expires + 'Timeout: ' + timeout)
    this.refreshTokenTimeout = setTimeout(() => this.refreshToken().subscribe(), timeout);
  }

  private stopRefreshTokenTimer() {
    clearTimeout(this.refreshTokenTimeout);
  }


  mouseMove(event) {
    event.preventDefault();
    clearInterval(this.intervaloSesionUsuario);
    this.iniciaInterval();
  }

  keyDown(event) {
    clearInterval(this.intervaloSesionUsuario);
    this.iniciaInterval();
  }

  iniciaInterval() {
    if (this.userValue === null) {
      return; // Si no hay usuario, ya no crea cierre automático de inactividad
    }
    this.intervaloSesionUsuario = setInterval(() => {
      clearInterval(this.intervaloSesionUsuario);
      this.swal.TypeTimer(() => this.logout(true), 'Cierre Sesión', 'Tu sesión esta por finalizar por inactividad', 59000);
    }, 900000); // 900000 ms - 15 minutos de inactividad
  }

  isUsuarioEspecial(): boolean {
    const isUsuarioEspecial = this.constants.USUARIOS_ESPECIALES.filter(e => e === this.idUsuario);
    if (isUsuarioEspecial.length == 0) {
      return true;
    } else {
      return false;
    }
  }

  cambioContrasena(): number {
    return this._utileria.getDiferenciaMeses(new Date(this.userValue.fechaCambioContrasena), new Date());
  }

}
